import Axios from "axios";
import React, { useState, useEffect, useContext, createContext } from "react";
import { Container } from "reactstrap";
import { Table, Button, Typography, Space } from "antd";
import { UserContext } from "../userComponents/UserContext";
import { Link } from "react-router-dom";

const { Title } = Typography;

export const MoviesContext = createContext();

const TableGamesComponent = (props) => {
  const [, setFilteredInfo] = useState(null);
  const [, setSortedInfo] = useState(null);
  const [games, setGames] = useState(null);
  const [user] = useContext(UserContext);

  useEffect(() => {
    if (games === null) {
      const url = `https://backendexample.sanbersy.com/api/data-game`;
      Axios.get(url).then((res) => {
        const data = res.data;
        setGames(data);
        console.log(data);
      });
    }
  }, [games]);

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };
  const handleDelete = (e) => {
    e.preventDefault();
    const id = e.target.id;
    const url = `https://backendexample.sanbersy.com/api/data-game/${id}`;
    Axios.delete(url, { headers: { Authorization: `Bearer ${user.token}` } })
      .then((res) => {
        console.log(res);
        setGames(null);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Genre",
      dataIndex: "genre",
      key: "genre",
    },
    {
      title: "SinglePlayer",
      dataIndex: "singlePlayer",
      key: "singlePlayer",
    },
    {
      title: "MultiPlayer",
      dataIndex: "multiplayer",
      key: "multiplayer",
    },
    {
      title: "Platform",
      dataIndex: "platform",
      key: "platform",
      tableLayout: "auto",
    },
    {
      title: "Release",
      dataIndex: "release",
      key: "release",
    },
    {
      title: "Action",
      key: "action",
      render: (e) => (
        <Space size="middle">
          <Link to={`/Edit/Games/${e.id}`}>
            <Button>Edit</Button>
          </Link>
          <Button id={e.id} onClick={handleDelete} title="Delete">
            Delete
          </Button>
        </Space>
      ),
      width: 200,
    },
  ];
  return (
    <Container className="mt-3 mb-2">
      <Title level={3}>Form Games</Title>
      <Link to="/fgames/input">
        <Button type="primary" className="mb-3">
          Input Game
        </Button>
      </Link>
      <Table columns={columns} dataSource={games} onChange={handleChange} />
    </Container>
  );
};

export default TableGamesComponent;
